/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";

export class LegalEntityVO extends JSONable{

  companyRegistrationUuid: string | null = null;
  legalEntityUuid: string | null = null;
  companyName: string | null = null;
  uniqueIdNumber: string | null = null;
  country: string | null = null;
  city: string | null = null;
  mainAddress: string | null = null;
  mainPhone: string | null = null;
  industryTypeValue: string | null = null;
  preferredLanguage: string | null = null;
  globalAccountCode: string | null = null;
  globalAccountTypeValue: string | null = null;
  vat: number | null = null;
  vatRegistration: boolean | null = null;
  vatSplitStatus: boolean | null = null;
  vatInactiveStatus: boolean | null = null;
  vatInactivationDate: string | null = null;
  mainEmailAddress: string | null = null;
  registrationCode: string | null = null;
  validated: boolean | null = null;

}
